import {useMemo} from 'react';
import {TimeScale, Version, Releases} from '../../../../../types';
import {getEntryTime} from '../utils';

const useReleases = (versions: Version[], timeScale: TimeScale): Releases =>
    useMemo(
        () =>
            versions.reduce((releases: Releases, {version, activated, displaced}: Version) => {
                const releaseEntryTime = getEntryTime(displaced || activated, timeScale);
                const release = releases[releaseEntryTime] || [];

                releases[releaseEntryTime] = [...release, {version, activated, displaced}];

                return releases;
            }, {}),
        [versions, timeScale]
    );

export default useReleases;
